import * as swcHelpers from '@swc/helpers';
import React__default from 'react';
import classnames from 'classnames';
import { Button } from '@grandvisionhq/common';
import { Heading } from '@grandvisionhq/elements';
import { Address } from '@grandvisionhq/locations';

const StoreLocation = (_param)=> {
    var { className , labels , addressSize , addressData , mapImageUrl , directionsUrl , distanceDetails =null , practicalInformation , onGetDirectionsClick  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "className",
        "labels",
        "addressSize",
        "addressData",
        "mapImageUrl",
        "directionsUrl",
        "distanceDetails",
        "practicalInformation",
        "onGetDirectionsClick"
    ]);
    return React__default.createElement("div", swcHelpers.extends({}, rest, {
        className: classnames('store-location-stores-v2', className)
    }), /*#__PURE__*/ React__default.createElement(Heading, {
        variant: "smallest",
        component: "h2"
    }, labels.title), mapImageUrl && /*#__PURE__*/ React__default.createElement("img", {
        className: "store-location-stores-v2__map",
        src: mapImageUrl,
        alt: labels.title,
        "data-t": "StaticMapImage"
    }), addressData && /*#__PURE__*/ React__default.createElement("span", {
        className: "store-location-stores-v2__subtitle"
    }, labels.address), /*#__PURE__*/ React__default.createElement(Address, {
        size: addressSize,
        data: addressData
    }), distanceDetails && /*#__PURE__*/ React__default.createElement("div", {
        className: "store-location-stores-v2__distance-details"
    }, distanceDetails), practicalInformation && /*#__PURE__*/ React__default.createElement("div", {
        className: "store-location-stores-v2__practical-information"
    }, /*#__PURE__*/ React__default.createElement("span", {
        className: "store-location-stores-v2__subtitle"
    }, labels.practicalInformationTitle), /*#__PURE__*/ React__default.createElement("p", null, practicalInformation)), directionsUrl && /*#__PURE__*/ React__default.createElement(Button, {
        className: "store-location-stores-v2__get-directions-button",
        hrefTarget: "_blank",
        icon: "location-pin",
        href: directionsUrl,
        onClick: onGetDirectionsClick,
        caption: labels.getDirections,
        variant: "outline"
    }));
};
var StoreLocation$1 = StoreLocation;

export { StoreLocation$1 as default };
//# sourceMappingURL=StoreLocation.js.map
